// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: 'Hem',
          component: () => import('@/views/home/Index.vue'),
        },
        {
          path: 'about',
          name: 'Om oss',
          component: () => import('@/views/about/Index.vue'),
          meta: { src: require('@/assets/about.jpg') },
        },
        {
          path: 'docs/user-agreement',
          name: 'UserAgreement',
          component: () => import('@/views/docs/UserAgreement.vue'),
          meta: { src: require('@/assets/people.jpg') },
        },
        {
          path: 'docs/privacy-policy',
          name: 'PrivacyPolicy',
          component: () => import('@/views/docs/PrivacyPolicy.vue'),
          meta: { src: require('@/assets/people.jpg') },
        },
        {
          path: 'product',
          name: 'Funktioner',
          component: () => import('@/views/pro/Index.vue'),
          meta: { src: require('@/assets/pro.png') },
        },
        {
          path: 'priser',
          name: 'Priser',
          component: () => import('@/views/pricing/Index.vue'),
          meta: { src: require('@/assets/pricing.jpg') },
        },
        {
          path: 'kontakt',
          name: 'Kontakt',
          component: () => import('@/views/contact-us/Index.vue'),
          meta: { src: require('@/assets/contact.jpg') },
        },
        {
          path: '*',
          name: 'FourOhFour',
          component: () => import('@/views/404/Index.vue'),
        },
      ],
    },

  ],
})

export default router
